import * as types from './Notifications.types';

const initialState = {
  notifications: [],
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_NOTIFICATION:
      const messages = state.notifications.slice(0);
      messages.unshift(action.data);
      return Object.assign({}, state, { notifications: messages });
    default:
      return state;
  }
};

export default notifications;
